// Registro comuni del territorio. Aggiungere un comune = aggiungere una riga qui,
// senza toccare l'architettura della mappa. active:false = "bloccato" (si sbloccherà).
export const COMUNI = [
  { id: "san-maurizio-canavese", name: "San Maurizio C.", center: [7.6312, 45.2167], active: true },
  { id: "cirie", name: "Ciriè", center: [7.6042, 45.2339], active: true },
  { id: "san-francesco-al-campo", name: "San Francesco al Campo", center: [7.6572, 45.2265], active: true },
  { id: "san-carlo-canavese", name: "San Carlo Canavese", center: [7.6152, 45.2554], active: true },
  { id: "nole", name: "Nole", center: [7.5724, 45.2480], active: true },
  { id: "mathi", name: "Mathi", center: [7.5510, 45.2677], active: true },
  { id: "robassomero", name: "Robassomero", center: [7.5689, 45.2000], active: true },
  { id: "vauda", name: "Vauda Canavese", center: [7.6201, 45.2804], active: true },
  { id: "grosso", name: "Grosso", center: [7.5579, 45.2575], active: true },
  { id: "palazzo-grosso", name: "Palazzo Grosso", center: [7.5700, 45.2560], active: true },
  { id: "leini", name: "Leinì", center: [7.7133, 45.1846], active: true },
  { id: "caselle", name: "Caselle", center: [7.6464, 45.1775], active: true },
  { id: "ceretta", name: "Ceretta", center: [7.6400, 45.2130], active: true },
  { id: "devesi", name: "Devesi", center: [7.6170, 45.2250], active: true },
  { id: "villanova-canavese", name: "Villanova Canavese", center: [7.5661, 45.2603], active: true },

  // Comuni futuri (bloccati) — trasmettono l'idea dello sblocco progressivo.
  { id: "venaria", name: "Venaria Reale", center: [7.6269, 45.1348], active: false },
  { id: "borgaro", name: "Borgaro", center: [7.6580, 45.1521], active: false },
  { id: "settimo", name: "Settimo T.", center: [7.7713, 45.1372], active: false },
  { id: "volpiano", name: "Volpiano", center: [7.7770, 45.2017], active: false },
  { id: "torino", name: "Torino", center: [7.6825, 45.0678], active: false },
];

export const TERRITORY_CENTER = [7.628, 45.225];

// Comune dichiarato → id comune (autoritativo per l'assegnazione sulla Mappa Viva).
const ZONE_MAP = {
  "san maurizio canavese": "san-maurizio-canavese", "san maurizio c.": "san-maurizio-canavese",
  "ciriè": "cirie", "cirie": "cirie", "san carlo canavese": "san-carlo-canavese",
  "caselle torinese": "caselle", "caselle": "caselle", "nole": "nole", "mathi": "mathi",
  "robassomero": "robassomero", "vauda canavese": "vauda", "grosso": "grosso",
  "palazzo grosso": "palazzo-grosso", "leinì": "leini", "leini": "leini",
  "san francesco al campo": "san-francesco-al-campo", "ceretta": "ceretta", "devesi": "devesi",
  "villanova canavese": "villanova-canavese", "villanova": "villanova-canavese",
};
export const zoneToComuneId = (zone) => ZONE_MAP[(zone || "").toLowerCase().trim()] || null;
export const TERRITORY_ZOOM = 10.6;   // vista d'insieme: comuni sulle posizioni reali, ben leggibili
export const ZOOM_THRESHOLD = 13;     // sotto = comuni, sopra = attività
export const COMUNE_ZOOM = 15.6;      // zoom quando entri in un comune
